
<table class="table table-striped mb-2 mt-3"> 
    <colgroup style="width: 100%">
      <col style="width: 5%">
      <col style="width: 44%;">
      @for(competitorWithGameRoundsPoints of competitorsWithGameRoundsPoints(); track competitorWithGameRoundsPoints) {
        <col style="width: 17%">
      }
      <col style="width: 17%">
    </colgroup>
    <thead app-competition-gameround-scroller         
          [viewPeriod]="viewPeriod()"
          [previousGameRound]="previousGameRound()"
          [gameRounds]="gameRounds()"
          [nextGameRound]="nextGameRound()"
          [activeGameRound]="activeGameRound()"
          [previousColSpan]="1"
          (previousPressed)="previousGameRoundPressed.emit()"          
          (gameRoundPressed)="gameRoundPressed.emit($event)"          
          (nextPressed)="nextGameRoundPressed.emit()"
        >      
    </thead>   
    <tbody>
      @for(competitorWithGameRoundsPoints of competitorsWithGameRoundsPoints(); track $index)
      {
        @let poolUser = competitorWithGameRoundsPoints.competitor.getPoolUser();
        <tr class="pointer" [class.current-user]="isCurrentUser(poolUser)">            
            <td class="rankingnr text-end ps-0"><!-- badge text-black -->
              @if(showTransfers()) {
                <button type="button"
                  class="btn btn-sm btn-outline-info me-2"
                  (click)="showCompetitorTransfers.emit(poolUser)">
                  T
                </button>
              } @else {
                <span class="">{{competitorWithGameRoundsPoints.rank}}</span>
              } 
            </td>
            
            <td class="text-break ps-0"
                (click)="linkToCompetitor.emit(competitorWithGameRoundsPoints)">
                <span class="fs-6">{{poolUser.getUser().getName()}}</span>
                <app-superelf-goat-icon
                  [userId]="poolUser.getUser().getId()"
                  [goatUserId]="goatUserId()"
                  [poolId]="poolId()">
                </app-superelf-goat-icon>
            </td>
            @for(gameRoundPoints of competitorWithGameRoundsPoints.gameRoundsPoints; track $index; let last=$last)
            {
              <td class="text-end ps-0 pointer" (click)="linkToCompetitor.emit(competitorWithGameRoundsPoints)">
                @let bestWorstBadgeClass = getBestWorstBadgeClass(poolUser, gameRoundPoints.number);
                <button type="button" class="btn btn-sm {{bestWorstBadgeClass}}">
                  {{gameRoundPoints.points}}
                </button>
              </td>
            }
            <td class="text-end ps-0" (click)="linkToCompetitor.emit(competitorWithGameRoundsPoints)">
                <button type="button" class="btn btn-sm btn-large-points fw-bold">
                  {{competitorWithGameRoundsPoints.viewPeriodsPoints}}
                </button>
            </td>
        </tr>
      }
    </tbody>
</table>

<ng-template #badgeCategoryModal let-modal>
    @let tmpBadgeCategory = badgeCategory();
    @if(tmpBadgeCategory){
      <div class="modal-header">
        <h4 class="modal-title">
          <span>
              <app-superelf-badge-icon [badgeCategory]="tmpBadgeCategory"></app-superelf-badge-icon>
              <span class="ms-1">{{nameService.getBadgeCategoryName(tmpBadgeCategory)}}-badge</span>
          </span>
        </h4>
        <button type="button" class="btn-close" aria-label="sluiten" (click)="modal.dismiss()"></button>
      </div>
    }
    <div class="modal-body">
      <p>De nummer 1 van de pool krijgt een zilveren badge. De nummer 1 van alle pools krijgt een gouden badge</p>
    </div>
    <div class="modal-footer d-flex justify-content-reverse border-top-0">
      <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modal.dismiss()">
        sluiten</button>
    </div>
</ng-template>
